import { Flex } from "@radix-ui/themes";
import { Cog6ToothIcon, CodeBracketIcon, ChatBubbleLeftRightIcon, GlobeAltIcon, BookOpenIcon } from "@heroicons/react/24/outline";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { MenuItem } from "components";
import { useProfileContext } from "context";

export function AIAssistantLayout() {
  const { userProfile } = useProfileContext();
  const location = useLocation();
  const navigate = useNavigate();
  const selection = location.pathname.endsWith("knowledge") ? "knowledge" : location.pathname.endsWith("website") ? "website" : location.pathname.endsWith("playground") ? "playground" : location.pathname.endsWith("installation") ? "installation" : "settings";
  return (
    <Flex gap="8" p="5" style={{ flex: "1 1 0", alignSelf: "stretch", minWidth: 0, overflow: "auto" }}>
      <Flex direction="column" gap="1" width="144px" style={{ flexShrink: 0 }}>
        {userProfile?.user_role === "Owner" && <MenuItem flag="playground" state={selection} onClick={() => navigate("/ai-assistant/playground")}
          text="Playground" tooltip="Test your organisation Assistant" icon={<ChatBubbleLeftRightIcon width={16} height={16} />} />}
        {userProfile?.user_role === "Owner" && <MenuItem flag="knowledge" state={selection} onClick={() => navigate("/ai-assistant/knowledge")}
          text="Knowledge" tooltip="Manage your Assistant's knowledge sources" icon={<BookOpenIcon width={16} height={16} />} />}
        <MenuItem flag="settings" state={selection} onClick={() => navigate("/ai-assistant/settings")}
          text="Settings" tooltip="Enable and configure your organisation Assistant" icon={<Cog6ToothIcon width={16} height={16} />} />
        {userProfile?.user_role === "Owner" && <MenuItem flag="website" state={selection} onClick={() => navigate("/ai-assistant/website")}
          text="Website" tooltip="Configure approved websites" icon={<GlobeAltIcon width={16} height={16} />} />}
        <MenuItem flag="installation" state={selection} onClick={() => navigate("/ai-assistant/installation")}
          text="Installation" tooltip="Install your Assistant on approved websites" icon={<CodeBracketIcon width={16} height={16} />} />
      </Flex>
      <Flex style={{ flex: "1 1 0", minWidth: 0 }}><Outlet /></Flex>
    </Flex>
  );
}
